import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Modal, Label, Grid, Icon, Button, Tab } from "semantic-ui-react";
import moment from "moment";

import printJS from "../../lib/print-js";
import CommunicationReplacementCarInfo from "./CommunicationReplacementCarInfo";
import { DESK_COMMUNICATION_EVENTS, COMMUNICATION_RESULT_STATUSES } from "./common";
import { getPriceForDisplay } from "./util";
import { getInterventionPriceWithVAT } from "../../util/common";

import "./DeskCommunicationLog.scss";

class DeskCommunicationLog extends Component {
  state = {
    isOpen: false,
    isAgreementModalOpen: false,
    isPrintLoading: false,
    selectedAgreement: null,
  };

  handleToggleAgreement = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleOpenAgreementModal = selectedAgreement => {
    this.setState({ isAgreementModalOpen: true, selectedAgreement });
  };

  handleCloseAgreementModal = () => {
    this.setState({ isAgreementModalOpen: false, selectedAgreement: null });
  };

  renderAppointmentInformation = () => {
    const { appointment, t } = this.props;

    return (
      <div className="info-section">
        <div className="section-header">
          <span>{t("appointment_information").message || "Appointment information"}</span>
        </div>
        <div className="section-content appointment-info-section">
          <div>
            <span className="icon-text">
              {t("wo_nr").message || "WO"} <Icon name="hashtag" color="green" />
            </span>
            {appointment.wo_nr}
          </div>

          <div>
            <span className="icon-text">
              {t("reg").message || "Reg."} <Icon name="hashtag" color="green" />
            </span>
            {appointment.reg_number}
          </div>

          <div>
            <span className="icon-text">
              VIN <Icon name="hashtag" color="green" />
            </span>
            {appointment.vin_nr}
          </div>

          {appointment.due_in && (moment.isMoment(appointment.due_in) || !appointment.due_in.startsWith("0001-01-01T00:00:00")) ? (
            <>
              <div>
                <Icon name="calendar alternate" color="green" />
                {moment(appointment.due_in).format("DD-MM-YYYY")}
              </div>

              <div>
                <Icon name="time" color="green" />
                {moment(appointment.due_in).format("HH:mm")}
              </div>
            </>
          ) : (
            appointment.time_car_app &&
            (moment.isMoment(appointment.time_car_app) || !appointment.time_car_app.startsWith("0001-01-01T00:00:00")) && (
              <div>
                <Icon name="calendar alternate" color="green" />
                {moment(appointment.time_car_app).format("DD-MM-YYYY")}
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  getInterventionPrice = intervention => {
    const price = getInterventionPriceWithVAT(intervention, this.props.location);
    if (price <= 0.01) return;

    return <span>{getPriceForDisplay(price)} €</span>;
  };

  communicationEventName = (event, t) => {
    switch (event.type) {
      case DESK_COMMUNICATION_EVENTS.CHECKIN_SENT:
        return t("sent").message || "Sent";

      case DESK_COMMUNICATION_EVENTS.CHECKIN_RECEIVED:
        return t("received").message || "received";

      case DESK_COMMUNICATION_EVENTS.CHECKIN_FAILED_TO_OPEN:
        return t("failed_to_open").message || "Failed to open";

      case DESK_COMMUNICATION_EVENTS.CHECKIN_OPENED:
        return t("opened").message || "Opened";

      case DESK_COMMUNICATION_EVENTS.CHECKIN_CANCELED:
        return t("canceled").message || "Canceled";

      case DESK_COMMUNICATION_EVENTS.CHECKIN_ANSWERED:
        return t("answered").message || "Answered";

      default:
        return "";
    }
  };

  communicationEventInfo = (event, comm) => {
    const fullname = event.type === DESK_COMMUNICATION_EVENTS.CHECKIN_SENT && comm.user && `${comm.user.first_name} ${comm.user.last_name}`;

    return (
      <Grid.Row width={16} className="section-rows">
        {fullname && (
          <span>
            <Icon name="user" color="green" />
            {fullname}
          </span>
        )}

        {event.customer_name && (
          <span>
            <Icon name="write" color="green" />
            {event.customer_name}
          </span>
        )}
      </Grid.Row>
    );
  };

  renderCommunicationEvents = comm => {
    const { t } = this.props;
    const { events } = comm;

    return (
      events?.length > 0 && (
        <div className="info-section">
          <div className="section-header">{t("communication_events").message || "Communication events"}</div>
          <div className="section-content">
            <Grid>
              {events.map((event, key) => {
                return (
                  <Grid.Row key={key}>
                    <Grid.Column width={12}>{this.communicationEventName(event, t)}</Grid.Column>

                    <Grid.Column width={4} className="event-timestamp">
                      {moment(event.created_on).format("HH:mm")} - {moment(event.created_on).format("DD-MM-YYYY")}
                    </Grid.Column>

                    {this.communicationEventInfo(event, comm)}
                  </Grid.Row>
                );
              })}
            </Grid>
          </div>
        </div>
      )
    );
  };

  renderAgreementModal = () => {
    const { selectedAgreement, isAgreementModalOpen } = this.state;
    return (
      selectedAgreement && (
        <Modal dimmer={true} closeOnDimmerClick={false} open={isAgreementModalOpen} onClose={this.handleCloseAgreementModal}>
          <Modal.Header>
            {selectedAgreement.name}
            <Button onClick={this.handleCloseAgreementModal} floated="right" color="green">
              {this.props.t("close").message || "Close"}
            </Button>
          </Modal.Header>
          <Modal.Content scrolling>
            <div dangerouslySetInnerHTML={{ __html: selectedAgreement.text }}></div>
          </Modal.Content>
        </Modal>
      )
    );
  };

  renderAgreements = agreements => {
    if (!agreements?.length) return null;
    const { t } = this.props;

    return (
      <div className="info-section">
        <div className="section-header">{t("agreements").message || "Agreements"}</div>
        <div className="section-content">
          <Grid>
            <Grid.Column width={16}>
              {agreements.map((item, key) => (
                <div className="agreements-label" key={key} onClick={() => this.handleOpenAgreementModal(item)}>
                  <Label>
                    <Icon name="check square" />
                  </Label>
                  <span className="-margin-left-10">{item.name}</span>
                </div>
              ))}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  };

  renderAgreedInterventions = agreed_interventions => {
    const { includeVAT, t } = this.props;

    if (!agreed_interventions?.length) return null;

    return (
      <div className="info-section">
        <div className="section-header">{this.props.t("accepted_scheduled_services").message || "Accepted scheduled services"}</div>
        <div className="section-content">
          <Grid>
            <Grid.Column width={16}>
              <div className="services-header">
                <span>{t("title").message || "Title"}</span>
                <span>{includeVAT ? t("price_inc_vat").message || "Price (incl. VAT)" : t("price_excl_vat").message || "Price (excl. VAT)"}</span>
              </div>
              {agreed_interventions.map((i, key) => (
                <div className="service" key={key}>
                  <span>{i.title}</span>
                  {this.getInterventionPrice(i)}
                </div>
              ))}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  };

  renderAgreedResults = results => {
    const { vat, t } = this.props;

    const agreedResults = results?.filter(result => [COMMUNICATION_RESULT_STATUSES.OK, COMMUNICATION_RESULT_STATUSES.AGREED].includes(result.status));

    if (!agreedResults?.length) return null;

    return (
      <div className="info-section">
        <div className="section-header">{this.props.t("accepted_extra_services").message || "Accepted extra services"}</div>
        <div className="section-content">
          <Grid>
            <Grid.Column width={16}>
              <div className="services-header">
                <span>{t("title").message || "Title"}</span>
                <span>{vat ? t("price_inc_vat").message || "Price (incl. VAT)" : t("price_excl_vat").message || "Price (excl. VAT)"}</span>
              </div>
              {agreedResults.map((i, key) => (
                <div className="service" key={key}>
                  <div className="service-title-remark-container">
                    <span>{i.title}</span>
                    {i.mechanic_notes && <span>{i.mechanic_notes}</span>}
                  </div>
                  <div className="service-price-container">
                    <span>{vat ? getPriceForDisplay(i.price * (1 + vat / 100)) : getPriceForDisplay(i.price)} €</span>
                  </div>
                </div>
              ))}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  };

  renderDeclinedInterventions = declined_interventions => {
    const { includeVAT, t } = this.props;

    if (!declined_interventions?.length) return null;

    return (
      <div className="info-section">
        <div className="section-header">{this.props.t("declined_scheduled_services").message || "Declined scheduled services"}</div>
        <div className="section-content">
          <Grid>
            <Grid.Column width={16}>
              <div className="services-header">
                <span>{t("title").message || "Title"}</span>
                <span>{includeVAT ? t("price_inc_vat").message || "Price (incl. VAT)" : t("price_excl_vat").message || "Price (excl. VAT)"}</span>
              </div>
              {declined_interventions.map((i, key) => (
                <div className="service" key={key}>
                  <span>{i.title}</span>
                  {this.getInterventionPrice(i)}
                </div>
              ))}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  };

  renderDeclinedResults = results => {
    const { vat, t } = this.props;

    const declinedResults = results?.filter(result => result.status === COMMUNICATION_RESULT_STATUSES.NOT_OK);

    if (!declinedResults?.length) return null;

    return (
      <div className="info-section">
        <div className="section-header">{this.props.t("declined_extra_services").message || "Declined extra services"}</div>
        <div className="section-content">
          <Grid>
            <Grid.Column width={16}>
              <div className="services-header">
                <span>{t("title").message || "Title"}</span>
                <span>{vat ? t("price_inc_vat").message || "Price (incl. VAT)" : t("price_excl_vat").message || "Price (excl. VAT)"}</span>
              </div>
              {declinedResults.map((i, key) => (
                <div className="service" key={key}>
                  <div className="service-title-remark-container">
                    <span>{i.title}</span>
                    {i.mechanic_notes && <span>{i.mechanic_notes}</span>}
                  </div>
                  <div className="service-price-container">
                    <div>{vat ? getPriceForDisplay(i.price * (1 + vat / 100)) : getPriceForDisplay(i.price)} €</div>
                  </div>
                </div>
              ))}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  };

  renderSignature = events => {
    const event = events.find(e => e.type === DESK_COMMUNICATION_EVENTS.CHECKIN_ANSWERED);

    if (!event?.customer_signature) return;

    return (
      <div className="info-section">
        <div className="section-header">{this.props.t("signature").message || "Signature"}</div>
        <div className="section-content">
          <Grid>
            {event.customer_name && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <span>
                    <Icon name="user" color="green" />
                    {event.customer_name}
                  </span>
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column width={4}>
                <img src={event.customer_signature} className="signature-img" alt="signature" />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  };

  renderTabContent = comm => {
    const { events, agreed_interventions, declined_interventions, results } = comm;

    const agreements = comm.agreements;

    return (
      <>
        {this.renderCommunicationEvents(comm)}
        {this.renderAgreedInterventions(agreed_interventions)}
        {this.renderDeclinedInterventions(declined_interventions)}
        {this.renderAgreedResults(results)}
        {this.renderDeclinedResults(results)}
        {this.renderAgreements(agreements)}
        {this.renderSignature(events)}
      </>
    );
  };

  renderTabs = () => {
    const { appointment, t } = this.props;
    const panes = [];

    appointment.desk_communications.forEach(comm => {
      panes.push({
        menuItem: comm.is_checking_out ? t("desk_check_out").message || "Desk Check-out" : t("desk_check_in").message || "Desk Check-in",
        render: () => this.renderTabContent(comm),
      });
    });
    return panes.length > 0 && <Tab menu={{ secondary: true }} panes={panes} />;
  };

  stopPrintLoading = () => this.setState({ isPrintLoading: false });

  handlePrint = () => {
    return this.setState({ isPrintLoading: true }, () => {
      printJS({
        printable: "desk-communication-agreement-content",
        type: "html",
        copyStyles: true,
        onLoadingEnd: this.stopPrintLoading,
        onError: this.stopPrintLoading,
      });
    });
  };

  render() {
    const { t, appointment } = this.props;

    if (!Array.isArray(appointment.desk_communications)) return null;

    return (
      <>
        <Modal
          closeOnDimmerClick={false}
          open={this.state.isOpen}
          onOpen={this.handleToggleAgreement}
          onClose={this.handleToggleAgreement}
          className="DeskCommunicationLog-Modal"
          trigger={
            <div className="comm-agreement-label">
              <Label>
                <Icon name="user" />
              </Label>
              <span className="-margin-right-15">{t("desk_comm_log").message || "Desk communication log"}</span>
            </div>
          }
        >
          <Modal.Header>
            <Icon name="list" />
            {t("desk_comm_log").message || "Desk communication log"}
            <Button onClick={this.handlePrint} loading={this.state.isPrintLoading} className="print-btn" color="green">
              {t("print").message || "Print"}
            </Button>
          </Modal.Header>
          <Modal.Content scrolling id="desk-communication-agreement-content">
            {this.renderAppointmentInformation()}
            <CommunicationReplacementCarInfo appointment={appointment} />
            {this.renderTabs()}
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleToggleAgreement}>{t("close").message || "Close"}</Button>
          </Modal.Actions>
        </Modal>
        {this.renderAgreementModal()}
      </>
    );
  }
}

export default withTranslation()(DeskCommunicationLog);
